import { jsonProperty, Serializable } from 'ts-serializable';
import type { Nullable } from './BaseTypes';

export class Trip extends Serializable {
    @jsonProperty(String) id: Nullable<string> = null;
    @jsonProperty(String) name: Nullable<string> = null;
    @jsonProperty(String) status: Nullable<string> = null;
    @jsonProperty(String) dateStart: Nullable<string> = null;
    @jsonProperty(String) dateEnd: Nullable<string> = null;
    @jsonProperty(String) dateStartDate: Nullable<string> = null;
    @jsonProperty(String) dateEndDate: Nullable<string> = null;
    @jsonProperty(String) departureDateAndTime: Nullable<string> = null;
    @jsonProperty(String) nameOfCompetition: Nullable<string> = null;
    @jsonProperty(String) cityOfCompetition: Nullable<string> = null;
    @jsonProperty(String) gatheringPlace: Nullable<string> = null;
    @jsonProperty(String) tripStudentId: Nullable<string> = null;
    @jsonProperty(String) studentId: Nullable<string> = null;
    @jsonProperty(String) studentName: Nullable<string> = null;
}
